import { Policy } from '@mui/icons-material'
import { Card, useTheme } from '@mui/material'
import { IconButtonWithTooltip } from '@src/components'
import { ROUTES } from '@src/data/routes'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditApplication } from '../../../data/types'

interface SideBarProps {
  isTopSideBarOpen: boolean
  isSideBarOpen: boolean
  app: CreditApplication
  lockCardHeight: number
  messageCardHeight: number
}

const CreditApplicationFraudSideBar = ({
  isTopSideBarOpen,
  isSideBarOpen,
  app,
  lockCardHeight,
  messageCardHeight,
}: SideBarProps) => {
  const theme = useTheme()
  const borderColor = theme.palette.divider
  const { t } = useTranslation()

  const calculateYOffest = () => {
    let height = 0
    if (isTopSideBarOpen)
      height += lockCardHeight * 0.06185 + 25
    if (isSideBarOpen)
      height += messageCardHeight * 0.06185 + 21
    return height > 0 ? height : 23.4
  }

  return (
    <Card
      style={{
        position: 'fixed',
        left: 0,
        top: `${calculateYOffest()}em`,
        zIndex: 999,
        padding: 0,
        margin: 0,
        msTransitionDuration: '300ms',
        transitionProperty: 'all',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderRadius: 2,
        borderColor,
      }}
    >
      <IconButtonWithTooltip
        tooltip={t('fraudFlags.title')}
        icon={<Policy />}
        onClick={() => window.open(ROUTES.applications.fraudFlags(app.financingProgramId, app.id), '_blank')}>
      </IconButtonWithTooltip>
    </Card>
  )
}

export default memo(CreditApplicationFraudSideBar)
